module.exports = __webpack_public_path__ + "img/message-chat-square.b1348b53.svg";